import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/team-members-icon.svg'
import _imports_1 from '../../assets/jyranians/gyranians-level-up.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-399ff7cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dashboard"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Change Pathway?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Oh no! If this pathway doesn't suit your current team development then you can change the pathway for your team. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Changing the Pathway for your team will affect all team members' current pathways. Click ‘Yes’ and you will be prompted to pick another pathway for your team. ", -1))
const _hoisted_5 = { class: "dashboard-background" }
const _hoisted_6 = { class: "container maxWidth-md text-big" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6 left-column" }
const _hoisted_9 = { class: "outcome-panel-content team-outcome" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { "data-test": "outcome-tile-title" }
const _hoisted_12 = {
  key: 1,
  "data-test": "outcome-tile-subtitle"
}
const _hoisted_13 = {
  style: {"margin-bottom":"10px"},
  "data-test": "outcome-tile-button",
  class: "btn btn-primary btn-large",
  type: "button"
}
const _hoisted_14 = { class: "col-sm-6 right-column" }
const _hoisted_15 = { class: "row top-row" }
const _hoisted_16 = { class: "col-sm-6 panel-container" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/resources/session/gyreinsights-team-solo-report" }, [
    /*#__PURE__*/_createElementVNode("span", null, "GyreInsights: Team Solo report"),
    /*#__PURE__*/_createElementVNode("span", { class: "beta-sticker" }, "BETA")
  ])
], -1))
const _hoisted_19 = { class: "col-sm-6 panel-container" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row bottom-row" }
const _hoisted_22 = { class: "col-sm-6 panel-container" }
const _hoisted_23 = {
  key: 0,
  class: "panel-head-container teq-head-container",
  "data-test": "has-teq-report-message"
}
const _hoisted_24 = {
  key: 1,
  "data-test": "need-more-responses-message",
  class: "tile-message"
}
const _hoisted_25 = {
  key: 2,
  "data-test": "start-new-review-message",
  class: "tile-message"
}
const _hoisted_26 = { class: "col-sm-6 panel-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "team-member-icon",
  alt: "team members icon",
  src: _imports_0
}, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "dashboard"
}
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<section class=\"dashboard-background\" data-v-399ff7cb><div class=\"container maxWidth-md text-big\" data-v-399ff7cb><div class=\"no-team-container\" data-v-399ff7cb><div class=\"no-team-img-container\" data-v-399ff7cb><img src=\"" + _imports_1 + "\" alt=\"level up\" data-v-399ff7cb></div><div style=\"height:20px;\" data-v-399ff7cb></div><a class=\"btn btn-primary\" href=\"/team/create/\" data-v-399ff7cb>Setup a new team</a></div></div></section>", 1)
const _hoisted_30 = [
  _hoisted_29
]

import { debug as d } from "debug";
import axios from "axios";
import { Modal } from "uiv";
import { computed, onBeforeMount, ref } from "vue";
import {
  TeamApiModel,
  TeamCurrentAndPendingMembersApiModel,
  TeamEffectivenessReviewApiModel,
  TeamPathwayApiModel,
  TeamMemberCompletedPathwayStepApiModel,
  TeamSettingsApiModel,
} from "../../api-models";
import { settleAll } from "../../services/utilities/settle-all";
import LoadingPage from "../loading-page.vue";
import DashboardPanel from "../../components/dashboard-panel.vue";
import HeadFromModel from "../../components/head/head-from-model.vue";
import { csContext } from "../../services/cs-context";
import Stepper from "../../components/team-outcomes/progress-stepper.vue";
import cms from "../../services/cms/cms";
import { CmsTeamPathway } from "../../services/cms/cms-type-definitions";
import TileKebabMenu from "../../components/tile-kebab-menu.vue";

export interface TeamOutcomeTile {
  buttonUrl: string;
  imgSrc: string;
  buttonText: string;
  panelTitle: string;
  panelSubtitle: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'team-dashboard',
  props: {
    id: {},
    isTeamLeader: { type: Boolean },
    teamSettingsModel: {},
    teamModel: {}
  },
  setup(__props: any) {

const debug = d("cs.TeamDashboardPage");

const props = __props;

const isInTeam = ref(false);
const isDataLoaded = ref(false);
const isSoloDiamondLoaded = ref(false);
const isViewpointsDiamondLoaded = ref(false);
const isTeamEffectivenessLoaded = ref(false);
const hasTeamSoloReport = ref<boolean | null>(null);
const hasTeamViewpointsReport = ref<boolean | null>(null);
const hasTeamEffectivenessData = ref<boolean | null>(null);
const latestTeqReport = ref<TeamEffectivenessReviewApiModel | null>(null);
const isChangePathwayModalOpen = ref(false);
const pathwayDoc = ref<CmsTeamPathway | null>(null);
const currentPathway = ref<TeamPathwayApiModel | null>(null);
const userProgress = ref<TeamMemberCompletedPathwayStepApiModel | null>(null);
const outcomeImgUrl = ref<string>();
const currentAndPendingMembers = ref<TeamCurrentAndPendingMembersApiModel | null>(null);
const hasTeamMemberCompletedPathway = ref<boolean | null>(null);

const teamOutcomeTile = computed(() => {
  return {
    panelSubtitle: "",
    panelTitle: "Browse pathways",
    buttonText: "Go",
    // eslint-disable-next-line global-require
    imgSrc: require("../../assets/jyranians-mountain.png"),
    buttonUrl: `/team/outcomes/${props.id}/select`,
  };
});

const hasTeqReport = computed(
  () => !!latestTeqReport.value && latestTeqReport.value?.questionnaires?.length > 1,
);

const latestTeqReportId = computed(() => latestTeqReport.value?.id);
const pathwayStepCount = computed(() => pathwayDoc.value?.data.pathway_steps.length ?? 0);
const completedStep = computed(() => userProgress.value?.stepIndex ?? -1);
const isTeamLeaderOrOrgAdmin = computed(
  () => props.isTeamLeader || csContext.userProfile.isOrgAdmin,
);

function soloDiamondLoaded(hasData: boolean): void {
  debug("soloDiamondLoaded", hasData);
  isSoloDiamondLoaded.value = true;
  hasTeamSoloReport.value = hasData;
}

function viewpointsDiamondLoaded(hasData: boolean): void {
  debug("viewpointsDiamondLoaded", hasData);
  isViewpointsDiamondLoaded.value = true;
  hasTeamViewpointsReport.value = hasData;
}

function teamEffectivenessLoaded(hasData: boolean): void {
  debug("teamEffectivenessLoaded", hasData);
  isTeamEffectivenessLoaded.value = true;
  hasTeamEffectivenessData.value = hasData;
}

async function setOutcomeUserProgressAndPathway(): Promise<void> {
  const resp = await axios.get(`/api/TeamPathway/${props.id}`);
  currentPathway.value = resp.data.teamPathway;
  userProgress.value = resp.data.userProgress;
  if (currentPathway.value) {
    pathwayDoc.value = await cms.getById("cms-pathway", currentPathway.value.cmsPathwayId);
    outcomeImgUrl.value = (
      await cms.getById("cms-goal", currentPathway.value.cmsOutcomeId)
    ).data.image.url;
  }
}

function isLastStepCompleted(): boolean {
  const currentPathwayId = currentPathway.value?.cmsPathwayId;
  if (currentPathwayId && pathwayDoc.value) {
    const pathwaySteps = pathwayDoc.value.data.pathway_steps;
    const lastPathwayStep = pathwaySteps[pathwaySteps.length - 1];
    const lastPathwayStepId = lastPathwayStep.pathway_step.id;
    // does the last step match the users current step and has it been completed
    return lastPathwayStepId === userProgress.value?.cmsStepId;
  }
  return false;
}

function setOutcomeTileContent(): void {
  if (isTeamLeaderOrOrgAdmin.value) teamOutcomeTile.value.panelTitle = "Choose pathway";

  if (currentPathway.value?.completed) return;

  const completedLastStep = isLastStepCompleted();

  if (currentPathway.value?.cmsOutcomeTitle && currentPathway.value?.cmsPathwayTitle) {
    teamOutcomeTile.value.panelTitle = currentPathway.value.cmsOutcomeTitle;
    teamOutcomeTile.value.panelSubtitle = currentPathway.value.cmsPathwayTitle;
    if (completedLastStep && !currentPathway.value.completed) {
      teamOutcomeTile.value.buttonUrl =
        hasTeamMemberCompletedPathway.value && pathwayDoc.value
          ? cms.linkResolver(pathwayDoc.value)
          : "/team/complete/";
      teamOutcomeTile.value.buttonText = isTeamLeaderOrOrgAdmin.value
        ? "Complete Pathway"
        : "Continue";
    } else {
      teamOutcomeTile.value.buttonUrl = pathwayDoc.value ? cms.linkResolver(pathwayDoc.value) : "";
      teamOutcomeTile.value.buttonText = "Continue";
    }
    teamOutcomeTile.value.imgSrc = outcomeImgUrl.value;
  }
}

async function hasUserCompletedPathway(): Promise<void> {
  const response = await axios.get(
    `/api/TeamMemberCompletedPathway/${currentPathway.value?.cmsPathwayId}/${props.id}`,
  );

  hasTeamMemberCompletedPathway.value = await response.data;

  const hasViewedCompletePage = userProgress.value?.hasViewedCompletePage;

  if (
    !hasTeamMemberCompletedPathway.value &&
    userProgress.value?.teamPathwayIsCurrent &&
    !hasViewedCompletePage
  ) {
    window.location.href = "/team/complete/";
  }
}

onBeforeMount(async () => {
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 100);

  if (!props.id) {
    isDataLoaded.value = true;
    return;
  }

  isInTeam.value = true;

  const promises: Promise<void>[] = [];

  // promises.push(
  //   axios.get("/api/ReportPermissions/").then((resp) => {
  //     reportPermissionDialogModel.value = resp.data as ReportPermissionDialogModel;
  //   }),
  // );

  promises.push(
    axios.get(`/api/TeamMembership/${props.id}`).then((resp) => {
      currentAndPendingMembers.value = resp.data as TeamCurrentAndPendingMembersApiModel;
    }),
  );

  promises.push(
    axios.get(`/api/TeamEffectivenessReview/GetLatestForTeam?teamId=${props.id}`).then((resp) => {
      const data = resp.data as TeamEffectivenessReviewApiModel;
      if (data && data.id) {
        latestTeqReport.value = data;
      }
    }),
  );

  promises.push(setOutcomeUserProgressAndPathway());

  await settleAll(promises);
  setOutcomeTileContent();
  isDataLoaded.value = true;
  debug(csContext);

  if (currentPathway.value?.completed) {
    await hasUserCompletedPathway();
  }
});

function changePathway(): void {
  isChangePathwayModalOpen.value = true;
}

function handleChangePathwayHide(msg: "ok" | "cancel"): void {
  if (msg === "ok") {
    window.location.href = `/team/outcomes/${props.id}/select`;
  }
}

return (_ctx: any,_cache: any) => {
  return (isInTeam.value && isDataLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Modal), {
          modelValue: isChangePathwayModalOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChangePathwayModalOpen).value = $event)),
          title: "Change Pathway?",
          "ok-text": "Yes",
          "cancel-text": "Cancel",
          "ok-type": "default",
          "cancel-type": "primary",
          onHide: handleChangePathwayHide,
          size: "md"
        }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(DashboardPanel, {
                  title: "Our Pathway",
                  href: teamOutcomeTile.value.buttonUrl
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (
                    isTeamLeaderOrOrgAdmin.value &&
                    currentPathway.value?.cmsPathwayId &&
                    !currentPathway.value.completed
                  )
                        ? (_openBlock(), _createBlock(TileKebabMenu, {
                            key: 0,
                            "data-test": "kebab-menu"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _withModifiers(changePathway, ["stop","prevent"]),
                                  "data-test": "change-outcome"
                                }, " Change pathway ")
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        alt: "your pathway image",
                        "data-test": "outcome-tile-img",
                        src: teamOutcomeTile.value.imgSrc,
                        class: "outcome-tile-default-img",
                        width: "80%"
                      }, null, 8, _hoisted_10),
                      _createElementVNode("h3", _hoisted_11, _toDisplayString(teamOutcomeTile.value.panelTitle), 1),
                      (teamOutcomeTile.value.panelSubtitle)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(teamOutcomeTile.value.panelSubtitle), 1))
                        : _createCommentVNode("", true),
                      (currentPathway.value?.cmsPathwayId && userProgress.value && !currentPathway.value.completed)
                        ? (_openBlock(), _createBlock(Stepper, {
                            key: 2,
                            "data-test": "outcome-tile-progress",
                            "completed-step": completedStep.value,
                            "steps-count": pathwayStepCount.value,
                            "show-tooltip": true
                          }, null, 8, ["completed-step", "steps-count"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", _hoisted_13, _toDisplayString(teamOutcomeTile.value.buttonText), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(DashboardPanel, {
                      href: `/TeamReport/view/${_ctx.id}`,
                      title: "Team Solo",
                      "tooltip-text": "Our Team Solo shows all of our solo reports aggregated together. This is how our team views itself.",
                      "is-clickable": !!(isSoloDiamondLoaded.value && hasTeamSoloReport.value)
                    }, {
                      default: _withCtx(() => [
                        (isSoloDiamondLoaded.value && !hasTeamSoloReport.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Your team needs at least two members with Solo reports to have a Team report. "))
                          : (!isSoloDiamondLoaded.value || hasTeamSoloReport.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ hidden: !isSoloDiamondLoaded.value || !hasTeamSoloReport.value }, "panel-head-container"])
                              }, [
                                _createVNode(TileKebabMenu, {
                                  ref: "soloTileKebab",
                                  "data-test": "solo-kebab-menu"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                }, 512),
                                _createVNode(HeadFromModel, {
                                  animateEntrance: true,
                                  headId: _ctx.id,
                                  kind: "teamsolo",
                                  onOnDataLoaded: soloDiamondLoaded
                                }, null, 8, ["headId"])
                              ], 2))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["href", "is-clickable"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(DashboardPanel, {
                      title: "Team Viewpoints",
                      href: `/teamviewpointsreport/view/${_ctx.id}`,
                      "tooltip-text": "Our Team Viewpoints report shows all our viewpoints feedback aggregated together. This is how others view our team.",
                      "is-clickable": !!(isViewpointsDiamondLoaded.value && hasTeamViewpointsReport.value)
                    }, {
                      default: _withCtx(() => [
                        (isViewpointsDiamondLoaded.value && !hasTeamViewpointsReport.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Your team needs at least two members with Viewpoints reports to have a Team Viewpoints report. "))
                          : (!isViewpointsDiamondLoaded.value || hasTeamViewpointsReport.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ hidden: !isViewpointsDiamondLoaded.value || !hasTeamViewpointsReport.value }, "panel-head-container"])
                              }, [
                                _createVNode(HeadFromModel, {
                                  animateEntrance: true,
                                  headId: _ctx.id,
                                  kind: "teamviewpoints",
                                  onOnDataLoaded: viewpointsDiamondLoaded
                                }, null, 8, ["headId"])
                              ], 2))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["href", "is-clickable"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(DashboardPanel, {
                      "data-test": "team-effectiveness-tile",
                      title: "Team Effectiveness",
                      "tooltip-text": "Our Team Effectiveness Questionnaire displays our ratings of our team against Gyre’s 9 Questions Model.",
                      href: `/team/effectiveness/${_ctx.id}`
                    }, {
                      default: _withCtx(() => [
                        (hasTeqReport.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(HeadFromModel, {
                                kind: "TeamEffectivenessAggregateDiamond",
                                headId: latestTeqReportId.value,
                                onOnDataLoaded: teamEffectivenessLoaded,
                                animateEntrance: true
                              }, null, 8, ["headId"])
                            ]))
                          : (latestTeqReport.value?.questionnaires?.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, " You need at least 2 responses to view the latest Team Effectiveness report. "))
                            : (_openBlock(), _createElementBlock("p", _hoisted_25, " Your team can start a new Team Effectiveness Review at any time. "))
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(DashboardPanel, {
                      title: "Team Members",
                      href: `/team/members/${_ctx.id}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (!isInTeam.value && isDataLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
      : (_openBlock(), _createBlock(LoadingPage, { key: 2 }))
}
}

})